import React from 'react'
import QrCode from '../assests/Qrcode.png'

function Footer() {
  return (

    <div className='md:h-full bg-gradient-to-br from-[#001002] via-[#000000] to-[#001002] pb-16 md:pb-8'>
      <div className='w-full  h-[2px] md:h-[3px]  bg-gradient-to-l from-[#a829fd] to-[#40AFFD]'>
      </div>
      <div className=' w-full md:h-full md:flex md:justify-evenly py-16 '>
        <div className='md:w-[1250px] h-fit m-auto md:flex md:justify-evenly'>
          <div className='p-5 text-center md:text-left flex flex-col gap-3'>
            <h1 className='text-white uppercase font-bold '>
              <span className='text-3xl md:text-4xl'>Look up on </span>
              <span className='text-3xl md:text-4xl text-[#3FCD54]'>InstaGram</span>
            </h1>
            <div className=' w-[70px] border mx-auto md:mx-0'></div>
            <p className='text-white text-sm md:text-base'>
              Scan the QR Code
            </p>
            <img className=' mx-auto md:mx-0 w-[200px] md:w-[350px]' src={QrCode} alt="" srcset="" />
          </div>
          <div className='p-5'>
            <div className=' text-white box2 p-6 flex flex-col justify-evenly 
         mx-auto md:mx-0 gap-2 h-full max-w-sm md:w-[370px]'>
              <h3>YOUR NAME</h3>
              <input className='p-1 bg-transparent border ' type="text" />
              <h3 >YOUR EMAIL</h3>
              <input className='p-1 bg-transparent border' type="email" name="" id="" />
              <h3>YOUR MESSAGE</h3>
              <textarea className='p-1 bg-transparent border' name="" id="" cols="30" rows="6"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className='text-center  flex flex-col gap-3'>
        <h1 className='uppercase text-[#3FCD54] font-semibold md:font-bold text-3xl md:text-4xl'>
          Brandifi
        </h1>
        <h2 className=' text-white font-thin'>CREATIVE AGENCY</h2>
        <div className=' w-[70px] border mx-auto'></div>
        <p className=' text-[#a6a4a4] font-extralight pt-5'>
          Copyright © 2003-2023 Brandifi Agency All rights reserved.
        </p>
      </div>
    </div>




  )
}

export default Footer
